import { render, staticRenderFns } from "./BaruManageAccount.vue?vue&type=template&id=2c6896ca&"
import script from "./BaruManageAccount.vue?vue&type=script&lang=js&"
export * from "./BaruManageAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports